import L from "leaflet";
import userSearchIcon from "../../resources/img/placeholder.png";

export default L.icon({
    iconUrl: userSearchIcon,
    iconSize: [30, 30],
    popupAnchor: [-0, -0],
});
